__turbopack_context__.v({
  "kit-card": "KitCard-module-scss-module__P3hlgG__kit-card",
  "kit-card__actions": "KitCard-module-scss-module__P3hlgG__kit-card__actions",
  "kit-card__badge": "KitCard-module-scss-module__P3hlgG__kit-card__badge",
  "kit-card__body": "KitCard-module-scss-module__P3hlgG__kit-card__body",
  "kit-card__description": "KitCard-module-scss-module__P3hlgG__kit-card__description",
  "kit-card__image": "KitCard-module-scss-module__P3hlgG__kit-card__image",
  "kit-card__info": "KitCard-module-scss-module__P3hlgG__kit-card__info",
  "kit-card__media": "KitCard-module-scss-module__P3hlgG__kit-card__media",
  "kit-card__sale-badge": "KitCard-module-scss-module__P3hlgG__kit-card__sale-badge",
  "kit-card__title": "KitCard-module-scss-module__P3hlgG__kit-card__title",
});
